
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta } from "/app/pages/[slug].vue?macro=true";
import { default as careerZtAdNTcsSJJmj9nwTKhdDAiT_Ve__SXtWLW_e_6dlPEMeta } from "/app/pages/career.vue?macro=true";
import { default as artistsYR9ed2ADnY5wsuf58AEgKWb1ljJKWqqr3pD2hgiRfqsMeta } from "/app/pages/artists.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as license0S52g6iTMruygl3iMmR_45S1dCtPUz64qZRjNPNxOipUAMeta } from "/app/pages/license.vue?macro=true";
import { default as articles4qJTG_45aAG7g49xw2jJsyZFUJKaYFnbvDXJD_45ryswoq8Meta } from "/app/pages/articles.vue?macro=true";
import { default as librettoQ8Ye01NpK4Bzk3iXusBUmHrww4GgrDQZ2rOjhiYIjocMeta } from "/app/pages/libretto.vue?macro=true";
import { default as catalogue_TMI_Qs6yHgcHiutGTyTShWrzvr_45gc8k_IiBr79whygMeta } from "/app/pages/catalogue.vue?macro=true";
import { default as for_45mediavpKs0730QV1CgilFEsDhvpohN3o1UblJmqbfHqYhRRIMeta } from "/app/pages/for-media.vue?macro=true";
import { default as newsletterWvr_45ldoWfuImUOgsCqZIsZVFmncZcSS9UXn1BfhV83IMeta } from "/app/pages/newsletter.vue?macro=true";
import { default as our_45partnersg7NDqne_45Lrg8au09siVzJSfFvkxpRxsPh9SOXJLX1qUMeta } from "/app/pages/our-partners.vue?macro=true";
import { default as prague_45storeeqaDz8ncptwmrGAGN0yeIuQifWuK16dJw_qpF6dcAy4Meta } from "/app/pages/prague-store.vue?macro=true";
import { default as _91slug_93yvIo8_450Es8ecJQgWcqJDJATJhRhYMD_45p11a4xwiy_YoMeta } from "/app/pages/artist/[slug].vue?macro=true";
import { default as _91slug_93U5op66TpI1Wy1bT_18ioovhvTQqxBFGqaJdV_455BbBuYMeta } from "/app/pages/article/[slug].vue?macro=true";
import { default as _91slug_93ThYOVAk1GMNeZIuI41xfWpiBxx1TBm0ScZxGXKly69wMeta } from "/app/pages/release/[slug].vue?macro=true";
import { default as index_BtZx_BuRAWbPHJ1TDooC6dGVYepRF6yutT5tG2_smAMeta } from "/app/pages/album/[slug]/index.vue?macro=true";
import { default as story_45of_45supraphonXDtd2hBt_l64ChpIBZ5ShXSJXNpl1D3KyF_9fmqBCqkMeta } from "/app/pages/story-of-supraphon.vue?macro=true";
import { default as _91audio_93fJxV1WeHGWtjMPOSR1KAPHkAZCGUevCyrDOhKQx1k7gMeta } from "/app/pages/album/[slug]/[audio].vue?macro=true";
import { default as information_45on_45the_45book_45entry_45of_45sharesUdidRfmoqsHy9Zt2lI3IZIbKjgLNRla2AZUQACVIEv0Meta } from "/app/pages/information-on-the-book-entry-of-shares.vue?macro=true";
export default [
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug___cs",
    path: "/cs/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "career___cs",
    path: "/cs/kariera",
    component: () => import("/app/pages/career.vue")
  },
  {
    name: "career___en",
    path: "/career",
    component: () => import("/app/pages/career.vue")
  },
  {
    name: "artists___cs",
    path: "/cs/umelci",
    component: () => import("/app/pages/artists.vue")
  },
  {
    name: "artists___en",
    path: "/artists",
    component: () => import("/app/pages/artists.vue")
  },
  {
    name: "contact___cs",
    path: "/cs/kontakty",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/contact-us",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "license___cs",
    path: "/cs/licence",
    component: () => import("/app/pages/license.vue")
  },
  {
    name: "license___en",
    path: "/licensing",
    component: () => import("/app/pages/license.vue")
  },
  {
    name: "articles___cs",
    path: "/cs/novinky",
    component: () => import("/app/pages/articles.vue")
  },
  {
    name: "articles___en",
    path: "/news",
    component: () => import("/app/pages/articles.vue")
  },
  {
    name: "libretto___cs",
    path: "/cs/libretto",
    component: () => import("/app/pages/libretto.vue")
  },
  {
    name: "libretto___en",
    path: "/libretto",
    component: () => import("/app/pages/libretto.vue")
  },
  {
    name: "catalogue___cs",
    path: "/cs/katalog",
    component: () => import("/app/pages/catalogue.vue")
  },
  {
    name: "catalogue___en",
    path: "/catalogue",
    component: () => import("/app/pages/catalogue.vue")
  },
  {
    name: "for-media___cs",
    path: "/cs/pro-media",
    component: () => import("/app/pages/for-media.vue")
  },
  {
    name: "for-media___en",
    path: "/for-media",
    component: () => import("/app/pages/for-media.vue")
  },
  {
    name: "newsletter___cs",
    path: "/cs/newsletter",
    component: () => import("/app/pages/newsletter.vue")
  },
  {
    name: "newsletter___en",
    path: "/newsletter",
    component: () => import("/app/pages/newsletter.vue")
  },
  {
    name: "our-partners___cs",
    path: "/cs/partneri",
    component: () => import("/app/pages/our-partners.vue")
  },
  {
    name: "our-partners___en",
    path: "/our-partners",
    component: () => import("/app/pages/our-partners.vue")
  },
  {
    name: "prague-store___cs",
    path: "/cs/prodejna",
    component: () => import("/app/pages/prague-store.vue")
  },
  {
    name: "prague-store___en",
    path: "/prague-store",
    component: () => import("/app/pages/prague-store.vue")
  },
  {
    name: "artist-slug___cs",
    path: "/cs/umelci/:slug()",
    component: () => import("/app/pages/artist/[slug].vue")
  },
  {
    name: "artist-slug___en",
    path: "/artists/:slug()",
    component: () => import("/app/pages/artist/[slug].vue")
  },
  {
    name: "article-slug___cs",
    path: "/cs/novinky/:slug()",
    component: () => import("/app/pages/article/[slug].vue")
  },
  {
    name: "article-slug___en",
    path: "/news/:slug()",
    component: () => import("/app/pages/article/[slug].vue")
  },
  {
    name: "release-slug___cs",
    path: "/cs/release/:slug()",
    component: () => import("/app/pages/release/[slug].vue")
  },
  {
    name: "release-slug___en",
    path: "/release/:slug()",
    component: () => import("/app/pages/release/[slug].vue")
  },
  {
    name: "album-slug___cs",
    path: "/cs/album/:slug()",
    component: () => import("/app/pages/album/[slug]/index.vue")
  },
  {
    name: "album-slug___en",
    path: "/album/:slug()",
    component: () => import("/app/pages/album/[slug]/index.vue")
  },
  {
    name: "story-of-supraphon___cs",
    path: "/cs/pribeh-supraphonu",
    component: () => import("/app/pages/story-of-supraphon.vue")
  },
  {
    name: "story-of-supraphon___en",
    path: "/story-of-supraphon",
    component: () => import("/app/pages/story-of-supraphon.vue")
  },
  {
    name: "album-slug-audio___cs",
    path: "/cs/alba/:slug()/:audio()",
    component: () => import("/app/pages/album/[slug]/[audio].vue")
  },
  {
    name: "album-slug-audio___en",
    path: "/albums/:slug()/:audio()",
    component: () => import("/app/pages/album/[slug]/[audio].vue")
  },
  {
    name: "information-on-the-book-entry-of-shares___cs",
    path: "/cs/informace-o-zaknihovani-akcii",
    component: () => import("/app/pages/information-on-the-book-entry-of-shares.vue")
  },
  {
    name: "information-on-the-book-entry-of-shares___en",
    path: "/information-on-the-book-entry-of-shares",
    component: () => import("/app/pages/information-on-the-book-entry-of-shares.vue")
  }
]